import React, { useState } from "react";
import { Box, Typography, List, ListItem, ListItemAvatar, ListItemText, Avatar, TextField, IconButton, InputAdornment } from "@mui/material";
import { ROLES } from "@/constants/data.const";
import { chatInboxStyles, messagesListSx, recentMessagesHeadingSx, searchInputProps, searchTextFieldSx } from "@/common/ChatInboxStyles";

const UserItem = ({ imgSrc, name, timestamp, isActive = true, onClick }) => {
  return (
    <ListItem button onClick={onClick} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <ListItemAvatar>
      <Avatar src={imgSrc} alt={`${name} avatar`} sx={{ bgcolor: "primary.main" }} />
      </ListItemAvatar>
      <ListItemText
        primary={name}
        secondary={timestamp? timestamp : "No messages yet"}
        sx={{
          flex: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          color: isActive ? "text.primary" : "text.disabled",
        }}
      />
    </ListItem>
  );
};

const MessagesSection = ({ conversations, userType, onSelectConversation }) => {
  return (
    <>
      <Typography variant="h6" sx={recentMessagesHeadingSx}>
        Recent messages
      </Typography>
      <List
        sx={messagesListSx}
      >
        {conversations.map((conv) => {
          const name =
            userType === "customer"
              ? `${conv.vendor?.first_name || ""} ${conv.vendor?.last_name || ""}`.trim()
              : `${conv.customer?.first_name || ""} ${conv.customer?.last_name || ""}`.trim();

          const imgSrc =
            userType === "customer"
              ? conv.vendor?.profile_picture?.file_url
              : conv.customer?.profile_picture?.file_url;

          const timestamp = conv.lastMessage?.createdAt
            ? new Date(conv.lastMessage.createdAt).toLocaleTimeString()
            : "No messages yet";

          const isActive =
            userType === "customer"
              ? !!conv.vendor?.profile_picture?.file_url
              : !!conv.customer?.profile_picture?.file_url;

          return (
            <UserItem
              key={conv._id}
              imgSrc={imgSrc}
              name={name || "Unknown User"}
              timestamp={timestamp}
              isActive={isActive}
              onClick={() => onSelectConversation(conv)}
            />
          );
        })}
      </List>
    </>
  );
};

const ChatInbox = ({ conversations, userType, onSelectConversation }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const filteredConversations = conversations.filter((conv) => {
    const userName = userType === "customer"
      ? `${conv.vendor?.first_name} ${conv.vendor?.last_name}`
      : `${conv.customer?.first_name} ${conv.customer?.last_name}`;
    return userName.toLowerCase().includes(searchQuery.toLowerCase());
  });

  return (
    <Box sx={chatInboxStyles}>
      <TextField
        fullWidth
        placeholder={userType === ROLES.CUSTOMER ? "Search brokers" : "Search customers"}
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        sx={searchTextFieldSx}
        InputProps={searchInputProps}
      />
      <MessagesSection
        onSelectConversation={onSelectConversation}
        conversations={filteredConversations}
        userType={userType}
      />
    </Box>
  );
};

export default ChatInbox;